import { IPageData } from 'app/utils/kentico';
import {
  ReviewHubPage as ReviewHubPageContent,
  getStaticProps as getStaticPropsReviewHubPage,
} from 'app/containers/ReviewHubPage/ReviewHubPage';

interface IReviewHubPageProps extends IPageData {}

const ReviewHubPage = (props: IReviewHubPageProps) => {
  return <ReviewHubPageContent {...props} />;
};

export async function getStaticProps() {
  return getStaticPropsReviewHubPage();
}

export default ReviewHubPage;
